import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { InfoGeneral } from 'app/shared/enums/info-general';
@Component({
  selector: 'app-need-help',
  imports: [MatIconModule],
  templateUrl: './need-help.component.html',
  styleUrl: './need-help.component.scss',
})
export class NeedHelpComponent {
  readonly dialogRef = inject(MatDialogRef<NeedHelpComponent>);
  tel = InfoGeneral.tel;
  telAf = InfoGeneral.telAf;
  email = InfoGeneral.email;
  onNoClick(): void {
    this.dialogRef.close();
  }
}
